export default (to, from, next) => {}



// WEBPACK FOOTER //
// ./src/router/afterEach.js